import React from "react";
import { Parallax } from "react-parallax";

function Counter() {
  return (
    ""
  );
}

export default Counter;
